import styled, { css } from 'styled-components'

type CategoryChooserProps<T> = {
  allElements: T[]
  allElementLabels?: string[]
  currentElement: T
  setCurrentElement: (category: T) => void
}

const Chooser = <T extends {}>({
  allElements,
  allElementLabels,
  currentElement,
  setCurrentElement,
}: CategoryChooserProps<T>) => {
  return (
    <div className='category-chooser'>
      {/* <h2>Categories</h2> */}
      <CategoryList>
        {allElements.map((category, index) => (
          <CategoryItem
            key={category.toString()}
            isActive={currentElement === category}
            onClick={() => setCurrentElement(category)}
          >
            {allElementLabels
              ? allElementLabels[index] ?? category.toString()
              : category.toString()}
          </CategoryItem>
        ))}
      </CategoryList>
    </div>
  )
}
const CategoryList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 1rem;
  margin-bottom: 1rem;
`
const CategoryItem = styled.li<{ isActive?: boolean }>`
  cursor: pointer;
  padding: 0 0.5em;
  border-radius: 0.5em;
  margin: 0.5em;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: var(--color-primary);
    color: var(--color-white);
  }
  ${({ isActive }) =>
    isActive &&
    css`
      font-weight: 700;
      /* border: 1px solid rgba(127, 127, 127, 0.5); */
      // soft shadow
      /* box-shadow: 0px 4.5px 1.3px rgba(0, 0, 0, 0.03),
    0px 8.6px 3.1px rgba(0, 0, 0, 0.035), 0px 12.7px 5.5px rgba(0, 0, 0, 0.037),
    0px 17.3px 9.2px rgba(0, 0, 0, 0.038), 0px 23.4px 15.1px rgba(0, 0, 0, 0.04),
    0px 33.5px 26.4px rgba(0, 0, 0, 0.047), 0px 60px 57px rgba(0, 0, 0, 0.07); */
    `}
`
export default Chooser
